import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUsePreventLockPresentingScreen: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'prevent-lock-presenting-screen')
  },
}

export default _getters
